/**
 * this file indexes all custom directives that will be registered globally in main.js
 */
import PermissionCanDirective from "./PermissionCanDirective";
import PermissionCanAnyDirective from "./PermissionCanAnyDirective";

export default {
    install (Vue) {
      Vue.directive('can', PermissionCanDirective);
      Vue.directive('canAny', PermissionCanAnyDirective);
    }
  }